import React from 'react';
import ApplyButtons from '../ApplyButtons';


interface Props {
    confirmHandler: (confirm: boolean) => void,
    rejectHandler: (confirm: boolean) => void
}


const FormHandleEventCayuga: React.FC<Props> = ({confirmHandler, rejectHandler}) => {
    return (
        <div className='event-form'>
            <div className='event-form__1row'>
                <div className="d-flex align-items-center">
                    <p className="confirm">Confirm</p>
                    <p className="reject">Reject</p>
                </div>
            </div>
            <ApplyButtons 
                    OKHandler={() => confirmHandler(true)} 
                    cancelHandler={() => rejectHandler(false)} 
                    disable={false} />
        </div>
    );
};

export default FormHandleEventCayuga;